import moment from "moment";
import { GalleryConfig, SocialProvider, GalleryFilters } from "src/types";
import { GalleryListElement } from "./components/GalleryItem/GalleryItem";
import { GallerySortByKey } from "./components/GallerySortBy/utils";
import { loadImage } from "src/utils/methods";

export const sortGalleryElements = (props: {
  data: GalleryListElement[];
  key: GallerySortByKey;
  config: GalleryConfig;
}) => {
  const { data, key, config } = props;

  if (!config.fullFetch) return data;

  return data.sort((a, b) => {
    switch (key) {
      case "publishedDate":
        return (
          new Date(b.publishedDate).getTime() -
          new Date(a.publishedDate).getTime()
        );

      case "er":
        return (b.engagementRate || 0) - (a.engagementRate || 0);

      case "likes":
      case "views":
      case "comments":
        return (b[key] || 0) - (a[key] || 0);

      default:
        return 0;
    }
  });
};

export const filterGalleryData = (
  data: GalleryListElement[] | undefined,
  filters: GalleryFilters,
  activeKeywords: string[],
  allKeywords: string[] | undefined = [],
) => {
  if (!data) return undefined;

  const filteredData = data.filter((item) => {
    if (Array.isArray(filters.platforms)) {
      const socialProvider = getSocialProvider(item.socialProvider);
      if (!filters.platforms.includes(socialProvider)) {
        return false;
      }
    }
    if (filters.dateFrom) {
      if (
        moment(item.publishedDate).startOf("day") < moment(filters.dateFrom)
      ) {
        return false;
      }
    }
    if (filters.dateTo) {
      if (moment(item.publishedDate).startOf("day") > moment(filters.dateTo)) {
        return false;
      }
    }
    if (
      allKeywords?.length > 0 &&
      !item.keywords?.some((el) => activeKeywords.includes(String(el)))
    ) {
      return false;
    }

    return true;
  });

  return filteredData;
};

const getSocialProvider = (socialProvider: string) => {
  if (socialProvider === "tik_tok") {
    return "tiktok";
  }

  return socialProvider;
};

export const filterByWorkingImage = async (data: GalleryListElement[]) => {
  const results = await Promise.all(
    data.map(async (item) => {
      try {
        if (item.socialProvider !== SocialProvider.Snapchat) {
          return item;
        }

        const isValid = await loadImage(item.thumbUrl);
        return isValid ? item : null;
      } catch (err) {
        return null;
      }
    }),
  );

  return results.filter((item): item is GalleryListElement => item !== null);
};
